import { consola } from 'consola';
import type {
  GetReferralCodeResponseDto,
  ApplyReferralCodeDto,
  ApplyReferralCodeResponseDto,
  ReferralStatsResponseDto,
  ValidateTokenResponseDto,
  ReferralAnalyticsResponseDto,
  GetReferralAnalyticsQueryDto,
} from '../model/types'
import { useApi } from '@shared/api'

const logger = consola.withTag('api-referral');

class APIReferral {
  async getMyReferralCode(): Promise<GetReferralCodeResponseDto> {
    try {
      const response = await useApi(true).get('/referral/my-code');
      return response.data;
    } catch (error: any) {
      logger.error('Ошибка получения реферального кода:', error?.data?.message || error?.message);
      throw error;
    }
  }

  async applyReferralCode(data: ApplyReferralCodeDto): Promise<ApplyReferralCodeResponseDto> {
    try {
      const response = await useApi(true).post('/referral/apply', { body: data });
      return response.data;
    } catch (error: any) {
      logger.error('Ошибка применения реферального кода:', error?.data?.message || error?.message);
      throw error;
    }
  }

  async getReferralStats(): Promise<ReferralStatsResponseDto> {
    try {
      const response = await useApi(true).get('/referral/stats');
      return response.data;
    } catch (error: any) {
      logger.error('Ошибка получения статистики:', error?.data?.message || error?.message);
      throw error;
    }
  }

  async validateToken(token: string): Promise<ValidateTokenResponseDto> {
    try {
      const response = await useApi(true).get('/referral/validate-token', { params: { token } });
      return response.data;
    } catch (error: any) {
      logger.error('Ошибка валидации токена:', error?.data?.message || error?.message);
      throw error;
    }
  }

  async getReferralAnalytics(params?: GetReferralAnalyticsQueryDto): Promise<ReferralAnalyticsResponseDto> {
    try {
      const response = await useApi(true).get('/referral/analytics', { params });
      return response.data;
    } catch (error: any) {
      logger.error('Ошибка получения аналитики:', error?.data?.message || error?.message);
      throw error;
    }
  }
}

const apiReferralInstance = new APIReferral();
export default apiReferralInstance;
export { apiReferralInstance as apiReferral };
